import React, { useEffect, useMemo, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { FiChevronDown, FiCheckCircle, } from 'react-icons/fi'
import { HiOutlineOfficeBuilding, } from 'react-icons/hi'
import { FaRunning } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { HiOutlineLocationMarker } from 'react-icons/hi'
import {
  HiOutlineTrophy,
  HiOutlineCursorArrowRays,
} from "react-icons/hi2";
import { BsBoxSeam } from 'react-icons/bs'
import { PiHandTapLight } from 'react-icons/pi'
import config from '../config/env'
import API from '../utils/apiCalling'

const PALETTE = ['#3B82F6', '#10B981', '#8B5CF6', '#F97316', '#EC4899', '#06B6D4', '#F59E0B']

function sum(arr, fn) {
  return arr.reduce((acc, x) => acc + fn(x), 0)
}
function pct(part, total) {
  if (!total) return 0
  return Math.round((part / total) * 1000) / 10
}

// function breakdownOf(d) {
//   return {
//     complete: {
//       saved: d?.complete?.saved || 0,
//       fullyCompleted: d?.complete?.complete || 0,
//     },
//     drop: {
//       saved: d?.drop?.saved || 0,
//       fullyCompleted: d?.drop?.complete || 0,
//     },
//     service: {
//       saved: d?.service?.saved || 0,
//       fullyCompleted: d?.service?.complete || 0,
//     },
//   }
// }
function breakdownOf(d) {
  return {
    complete: {
      saved: d?.complete?.saved || 0,
      fullyCompleted: d?.complete?.complete || 0,
      unComplete: d?.complete?.unComplete || 0,
      responseLimit: d?.complete?.responseLimit || 0,
    },
    drop: {
      saved: d?.drop?.saved || 0,
      fullyCompleted: d?.drop?.complete || 0,
      unComplete: d?.drop?.unComplete || 0,
      responseLimit: d?.drop?.responseLimit || 0,
    },
    service: {
      saved: d?.service?.saved || 0,
      fullyCompleted: d?.service?.complete || 0,
      unComplete: d?.service?.unComplete || 0,
      responseLimit: d?.service?.responseLimit || 0,
    },
  }
}

function groupTotal(g) {
  return (g?.saved || 0) + (g?.fullyCompleted || 0)
}

// ---------------------------------------------------------------------------
// Small UI pieces
// ---------------------------------------------------------------------------
function FilterSelect({ icon, label, value, onChange, options }) {
  return (
    <div className="dq-filter">
      <label className="dq-filter-label">{label}</label>
      <div className="dq-filter-box">
        <span className="dq-filter-icon">{icon}</span>
        <select value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="all">All {label}</option>
          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
        <FiChevronDown className="dq-filter-caret" />
      </div>
    </div>
  )
}

function StatCard({ icon, iconBg, title, value, subtitle }) {
  return (
    <div className="dq-stat-card">
      <div className="dq-stat-icon" style={{ background: iconBg }}>
        {icon}
      </div>
      <div>
        <div className="dq-stat-title">{title}</div>
        <div className="dq-stat-value">{value}</div>
        <div className="dq-stat-sub">{subtitle}</div>
      </div>
    </div>
  )
}

function Donut({ rows, total }) {
  const options = {
    chart: { type: 'donut' },
    labels: rows.map((r) => r.name),
    colors: rows.map((_, i) => PALETTE[i % PALETTE.length]),
    dataLabels: { enabled: false },
    legend: { show: false },
    stroke: { width: 2, colors: ['#fff'] },
    tooltip: { y: { formatter: (v) => v.toLocaleString() } },
    plotOptions: {
      pie: {
        donut: {
          size: '68%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total',
              fontSize: '13px',
              color: '#64748b',
              formatter: () => total.toLocaleString(),
            },
            value: {
              fontSize: '22px',
              fontWeight: 700,
              color: '#0f172a',
              offsetY: -4,
            },
          },
        },
      },
    },
  }
  const series = rows.map((r) => r.count)
  return <ReactApexChart options={options} series={series} type="donut" height={230} />
}

function SectionTable({ rows, total, countLabel, showBreakdown = false }) {
  return (
    <div className="dq-table-wrap">
      <table className="dq-table dq-table-grouped">
        <thead>
          <tr>
            <th rowSpan={showBreakdown ? 2 : 1} style={{ color: "#000", }}>#</th>
            <th rowSpan={showBreakdown ? 2 : 1} style={{ color: "#000", }}>{countLabel.name}</th>
            {showBreakdown ? (
              <>
                <th rowSpan={2} style={{ color: "#000", }}>{countLabel.countColumnLabel1 || 'Overall Target'}</th>
                <th rowSpan={2} style={{ color: "#000", }}>{countLabel.countColumnLabel || 'Overall Achieved'}</th>
              </>
            ) : (
              <th rowSpan={1} style={{ color: "#000", }}>Count</th>
            )}
            <th rowSpan={showBreakdown ? 2 : 1} style={{ color: "#000", }}>% of {countLabel.pctOf}</th>
            {showBreakdown && (
              <>
                <th colSpan={4} className="dq-group-head dq-group-start" style={{ color: "#000", }}>Complete</th>
                <th colSpan={4} className="dq-group-head dq-group-start" style={{ color: "#000", }}>Drop</th>
                <th colSpan={4} className="dq-group-head dq-group-start" style={{ color: "#000", }}>Service</th>
              </>
            )}
          </tr>
          {showBreakdown && (
            <tr>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Overall Quota</th>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Remaining Quota</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Saved</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Completed</th>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Overall Quota</th>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Remaining Quota</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Saved</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Completed</th>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Overall Quota</th>
              <th className="dq-sub-head dq-group-start" style={{ color: "#000", }}>Remaining Quota</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Saved</th>
              <th className="dq-sub-head" style={{ color: "#000", }}>Completed</th>
            </tr>
          )}
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={showBreakdown ? 14 : 4} className="dq-empty-row">
                No data available.
              </td>
            </tr>
          )}
          {rows.map((r, i) => (
            <tr key={r.name}>
              <td className="dq-idx">{i + 1}</td>
              <td className="dq-name">{r.name}</td>
              {showBreakdown ? (
                <>
                  <td className="dq-count">
                    {(
                      r.complete.responseLimit +
                      (r.complete.saved + r.complete.unComplete) +
                      r.complete.fullyCompleted +
                      r.drop.responseLimit +
                      (r.drop.saved + r.drop.unComplete) +
                      r.drop.fullyCompleted
                    ).toLocaleString()}
                  </td>
                  <td className="dq-count">
                    {(
                      (r.complete.saved + r.complete.unComplete) +
                      r.complete.fullyCompleted +
                      (r.drop.saved + r.drop.unComplete) +
                      r.drop.fullyCompleted
                    ).toLocaleString()}
                  </td>
                </>
              ) : (
                <td className="dq-count">{r.count.toLocaleString()}</td>
              )}
              <td>
                <div className="dq-pct-cell">
                  <span className="dq-pct-num">{pct(r.count, total)}%</span>
                  <div className="dq-bar-track">
                    <div
                      className="dq-bar-fill"
                      style={{
                        width: `${pct(r.count, total)}%`,
                        background: PALETTE[i % PALETTE.length],
                      }}
                    />
                  </div>
                </div>
              </td>
              {showBreakdown && (
                <>
                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {(r.complete.responseLimit) + (r.complete.saved + r.complete.unComplete) + (r.complete.fullyCompleted)}
                  </td>
                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {r.complete.responseLimit.toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">
                    {(r.complete.saved + r.complete.unComplete).toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">{r.complete.fullyCompleted.toLocaleString()}</td>

                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {(r.drop.responseLimit) + (r.drop.saved + r.drop.unComplete) + (r.drop.fullyCompleted)}
                  </td>
                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {r.drop.responseLimit.toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">
                    {(r.drop.saved + r.drop.unComplete).toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">{r.drop.fullyCompleted.toLocaleString()}</td>

                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {(r.service.responseLimit) + (r.service.saved + r.service.unComplete) + (r.service.fullyCompleted)}
                  </td>
                  <td className="dq-sub-cell dq-total-cell dq-group-start">
                    {r.service.responseLimit.toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">
                    {(r.service.saved + r.service.unComplete).toLocaleString()}
                  </td>
                  <td className="dq-sub-cell">{r.service.fullyCompleted.toLocaleString()}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="dq-table-footer">
        Showing 1–{rows.length} of {rows.length}
      </div>
    </div>
  )
}
function Legend({ rows, total }) {
  return (
    <div className="dq-legend">
      {rows.map((r, i) => (
        <div className="dq-legend-row" key={r.name}>
          <span className="dq-legend-dot" style={{ background: PALETTE[i % PALETTE.length] }} />
          <span className="dq-legend-name">{r.name}</span>
          <span className="dq-legend-value">
            {r.count.toLocaleString()}{' '}
            <span className="dq-legend-pct">({pct(r.count, total)}%)</span>
          </span>
        </div>
      ))}
    </div>
  )
}

function Section({ icon, iconBg, title, subtitle, rows, total, countLabel, rightControl, showBreakdown = false }) {
  return (
    <div className="dq-section">
      <div className="dq-section-head">
        <div className="dq-section-head-left">
          <div className="dq-section-icon" style={{ background: iconBg }}>
            {icon}
          </div>
          <div>
            <div className="dq-section-title">{title}</div>
            <div className="dq-section-sub text-dark">{subtitle}</div>
          </div>
        </div>
        {rightControl}
      </div>
      <div className="dq-section-body">
        <SectionTable rows={rows} total={total} countLabel={countLabel} showBreakdown={showBreakdown} />
        {/* <div className="dq-chart-col">
          <Donut rows={rows} total={total} />
          <Legend rows={rows} total={total} />
        </div> */}
      </div>
    </div>
  )
}
// ---------------------------------------------------------------------------
// Inline styles (no external CSS file needed)
// ---------------------------------------------------------------------------
const STYLES = `

.dq-loader {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.dq-orbit-wrap {
  position: relative;
  width: 168px;
  height: 168px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.dq-orbit-ring {
  position: absolute;
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 2px dashed #dbeafe;
}

.dq-orbit-ring-2 {
  width: 98px;
  height: 98px;
  border-color: #e2e8f0;
  animation: dq-ring-pulse 2.4s ease-in-out infinite;
}

@keyframes dq-ring-pulse {
  0%, 100% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.04); }
}

.dq-orbit-spin {
  position: absolute;
  width: 1px;
  height: 1px;
  animation: dq-orbit-rotate 5s linear infinite;
}

@keyframes dq-orbit-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.dq-orbit-item {
  position: absolute;
  top: 0;
  left: 0;
}

.dq-orbit-counter-spin {
  animation: dq-orbit-counter-rotate 5s linear infinite;
}

@keyframes dq-orbit-counter-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

.dq-orbit-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.1);
  animation: dq-icon-bounce 1.4s ease-in-out infinite;
}

@keyframes dq-icon-bounce {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.12); }
}

.dq-orbit-center {
  position: relative;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.18);
  animation: dq-center-pulse 1.8s ease-in-out infinite;
  z-index: 2;
}

@keyframes dq-center-pulse {
  0%, 100% { box-shadow: 0 4px 16px rgba(37, 99, 235, 0.18); }
  50% { box-shadow: 0 4px 26px rgba(37, 99, 235, 0.32); }
}

.dq-loader-text {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: baseline;
}

.dq-loader-dots span {
  animation: dq-dot-fade 1.4s infinite;
  opacity: 0;
}

.dq-loader-dots span:nth-child(1) { animation-delay: 0s; }
.dq-loader-dots span:nth-child(2) { animation-delay: 0.2s; }
.dq-loader-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes dq-dot-fade {
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
}

.dq-loader-sub {
  font-size: 12.5px;
  color: #94a3b8;
}

.dq-page {
  background: #f4f6fb;
  min-height: 100vh;
  padding: 24px 32px 48px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #0f172a;
}

/* ---------- Filters ---------- */
.dq-filters {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.dq-filter-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 6px;
}

.dq-filter-box {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 9px 12px;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.dq-filter-icon {
  color: #3b82f6;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.dq-filter-box select {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #1e293b;
  appearance: none;
  cursor: pointer;
}

.dq-filter-caret {
  color: #94a3b8;
  font-size: 14px;
}

/* ---------- Clear filters button ---------- */
.dq-filter-clear {
  display: flex;
  align-items: flex-end;
}

.dq-clear-btn {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 12px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.dq-clear-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #cbd5e1;
}

.dq-clear-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* ---------- Stat cards ---------- */
.dq-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.dq-stat-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.dq-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dq-stat-title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.dq-stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.dq-stat-sub {
  font-size: 12px;
  color: #94a3b8;
}

/* ---------- Section ---------- */
.dq-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.dq-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
}

.dq-section-head-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dq-section-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dq-section-title {
  font-size: 15.5px;
  font-weight: 700;
  color: #0f172a;
}

.dq-section-sub {
  font-size: 12.5px;
  color: #94a3b8;
}

.dq-badge {
  background: #eff6ff;
  color: #2563eb;
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 8px;
}

.dq-mini-select {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
}

.dq-mini-select-icon {
  color: #64748b;
  font-size: 14px;
}

.dq-mini-select select {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  color: #1e293b;
  appearance: none;
  cursor: pointer;
}

.dq-section-body {
  display: grid; 
  gap: 24px;
  align-items: start;
}

@media (max-width: 900px) {
  .dq-section-body {
    grid-template-columns: 1fr;
  }
  .dq-filters,
  .dq-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* ---------- Table ---------- */
.dq-table-wrap {
  overflow-x: auto;
}

.dq-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.dq-table thead th {
  text-align: left;
  font-weight: 600;
  color: #64748b;
  background: #f8fafc;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.dq-table-grouped thead th {
  text-align: center;
}

.dq-table-grouped thead tr:first-child th:nth-child(1),
.dq-table-grouped thead tr:first-child th:nth-child(2) {
  text-align: left;
}

.dq-group-head {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #475569;
  background: #f1f5f9;
}

.dq-sub-head {
  font-size: 11.5px;
  font-weight: 600;
  color: #94a3b8;
}

.dq-group-start {
  border-left: 1px solid #e2e8f0;
}

.dq-sub-cell {
  text-align: center;
  color: #475569;
  font-variant-numeric: tabular-nums;
}

.dq-total-cell {
  font-weight: 700;
  color: #0f172a;
  background: #f8fafc;
}

.dq-table tbody td {
  padding: 11px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.dq-idx {
  color: #94a3b8;
  width: 28px;
}

.dq-name {
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
}

.dq-count {
  font-weight: 600;
  color: #1e293b;
}

.dq-pct-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 160px;
}

.dq-pct-num {
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  width: 42px;
  flex-shrink: 0;
}

.dq-bar-track {
  flex: 1;
  height: 7px;
  background: #eef2f7;
  border-radius: 999px;
  overflow: hidden;
}

.dq-bar-fill {
  height: 100%;
  border-radius: 999px;
}

.dq-table-footer {
  font-size: 12px;
  color: #94a3b8;
  padding: 10px 4px 0;
}

.dq-empty-row {
  text-align: center;
  color: #94a3b8;
  padding: 24px 12px;
}

/* ---------- Chart column ---------- */
.dq-chart-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.dq-legend {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-top: 4px;
}

.dq-legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.dq-legend-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dq-legend-name {
  flex: 1;
  color: #334155;
}

.dq-legend-value {
  font-weight: 600;
  color: #0f172a;
}

.dq-legend-pct {
  font-weight: 500;
  color: #94a3b8;
}


/* ---------- Organization access states ---------- */
.dq-loading {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #64748b;
}

.dq-api-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
}

.dq-locked-info {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 16px;
  color: #334155;
  font-size: 13px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.dq-locked-badge {
  margin-left: auto;
  background: #f1f5f9;
  color: #475569;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.dq-filter-box-disabled {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.dq-filter-box select:disabled,
.dq-mini-select select:disabled {
  color: #475569;
  cursor: not-allowed;
  opacity: 1;
}

.dq-mini-select-disabled {
  background: #f8fafc;
  border-color: #cbd5e1;
}
  .dq-invalid-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f8fafc;
    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, sans-serif;
    box-sizing: border-box;
  }

  .dq-invalid-card {
    width: 100%;
    max-width: 580px;
    padding: 48px 40px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #0055ff;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  }

  .dq-invalid-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fef2f2;
    color: #dc2626;
    font-size: 32px;
    font-weight: 700;
    border: 8px solid #fee2e2;
  }

  .dq-invalid-title {
    margin: 0 0 14px;
    color: #111827;
    font-size: 28px;
    line-height: 1.25;
    font-weight: 700;
    letter-spacing: -0.02em;
  }

  .dq-invalid-text {
    margin: 0 auto 8px;
    max-width: 430px;
    color: #6b7280;
    font-size: 15px;
    line-height: 1.6;
  }

  .dq-invalid-button {
    margin-top: 24px;
    padding: 12px 24px;
    border: 0;
    border-radius: 10px;
    background: #111827;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease;
  }

  .dq-invalid-button:hover {
    background: #1f2937;
    transform: translateY(-1px);
  }

  .dq-invalid-button:focus-visible {
    outline: 3px solid #93c5fd;
    outline-offset: 3px;
  }

  .dq-invalid-help {
    margin: 24px 0 0;
    color: #9ca3af;
    font-size: 13px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    .dq-invalid-page {
      padding: 16px;
    }

    .dq-invalid-card {
      padding: 36px 24px;
      border-radius: 16px;
    }

    .dq-invalid-title {
      font-size: 24px;
    }
  }
`

// ---------------------------------------------------------------------------
// Empty-shape default for the quota API response, so destructuring never
// blows up before the first successful call resolves.
// ---------------------------------------------------------------------------
const EMPTY_QUOTA = {
  organizationWise: { overallCount: 0, data: [] },
  productNameWise: { data: [] },
  allTouchpointWise: { data: [] },
  overview: { overallCount: 0 },
}

// Empty-shape default for the dropdown-options API response.
const EMPTY_DROPDOWN_OPTIONS = {
  organizations: [],
  products: [],
  cities: [],
  touchpoints: [],
}

function Quota() {
  const api = new API
  const [orgFilter, setOrgFilter] = useState('all')
  const [cityFilter, setCityFilter] = useState('all')

  const [organizationData, setOrganizationData] = useState([])
  const [loadingOrganizations, setLoadingOrganizations] = useState(true)
  const [organizationError, setOrganizationError] = useState('')

  // Product / city / touchpoint dropdown options, from getDropdownData.
  // Always the full lists -- independent of whatever filters are applied --
  // so the dropdowns don't reshape themselves as the user filters.
  const [dropdownOptions, setDropdownOptions] = useState(EMPTY_DROPDOWN_OPTIONS)

  const [selectedOrg, setSelectedOrg] = useState('')
  const [selectedProduct, setSelectedProduct] = useState('')
  const [selectedTouchpoint, setSelectedTouchpoint] = useState('')
  const [overallCount, setOverallCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------------------
  // Quota data (organizationWise / productNameWise / allTouchpointWise)
  // fetched from getFieldAuditorOrganizationData.
  // ------------------------------------------------------------
  const [quota, setQuota] = useState(EMPTY_QUOTA)
  const [loadingQuota, setLoadingQuota] = useState(true)
  const [quotaError, setQuotaError] = useState('')

  // ------------------------------------------------------------
  // Get organization _id from URL
  // Example:
  // http://doYourSurvey.com/#/quota/6aae13c9a988b2062cc443a4
  // ------------------------------------------------------------
  const urlOrganizationId = useMemo(() => {
    const hash = window.location.hash || ''
    const match = hash.match(/^#\/quota\/([^/?#]+)/i)
    return match ? match[1] : null
  }, [])

  // ------------------------------------------------------------
  // Get organizations (URL access control) + dropdown option lists
  // ------------------------------------------------------------
  useEffect(() => {
    let mounted = true

    const getOrganizations = async () => {
      try {
        setLoadingOrganizations(true)
        setOrganizationError('')

        const result = await api.post(
          `${config.new.site_api}/survey/getAllOrganizations`,
          {}
        )
        const dropdownDatas = await api.post(
          `${config.new.site_api}/survey/getDropdownData`,
          {}
        )


        // Supports both:
        // 1. result = []
        // 2. result.data = []
        const data = Array.isArray(result)
          ? result
          : Array.isArray(result?.data)
            ? result.data
            : Array.isArray(result?.data?.data)
              ? result.data.data
              : []

        // Supports both `dropdownDatas.data` and `dropdownDatas.data.data` shapes.
        const dropdownPayload =
          dropdownDatas?.data?.data || dropdownDatas?.data || dropdownDatas || {}

        // Each dropdown list comes back as an array of objects
        // ({ _id, productId, productName } etc.), not plain strings.
        const toNames = (arr, key) =>
          Array.isArray(arr) ? arr.map((item) => item?.[key]).filter(Boolean) : []

        if (mounted) {
          setOrganizationData(data)
          setDropdownOptions({
            organizations: toNames(dropdownPayload.fieldOrganization, 'organizationName'),
            products: toNames(dropdownPayload.products, 'productName'),
            cities: toNames(dropdownPayload.cities, 'cityName'),
            touchpoints: toNames(dropdownPayload.touchpoints, 'touchpointName'),
          })
        }
      } catch (error) {
        console.error(
          'Error while getting field auditor organization data:',
          error
        )

        if (mounted) {
          setOrganizationData([])
          setDropdownOptions(EMPTY_DROPDOWN_OPTIONS)
          setOrganizationError('Unable to load organizations.')
        }
      } finally {
        if (mounted) {
          setLoadingOrganizations(false)
        }
      }
    }

    getOrganizations()

    return () => {
      mounted = false
    }
  }, [])

  // ------------------------------------------------------------
  // Find organization using _id from URL
  // ------------------------------------------------------------
  const urlOrganization = useMemo(() => {
    if (!urlOrganizationId) return null

    return organizationData.find(
      (organization) =>
        String(organization?._id) === String(urlOrganizationId)
    ) || null
  }, [organizationData, urlOrganizationId])

  const isInvalidOrganizationUrl =
    !loadingOrganizations &&
    Boolean(urlOrganizationId) &&
    !urlOrganization

  // ------------------------------------------------------------
  // IMPORTANT ACCESS LOGIC
  //
  // disabled === true:
  //   Only URL-matched organization is available.
  //   Organization dropdown is disabled.
  //
  // disabled === false:
  //   All organizations are available.
  //   Organization dropdown is enabled.
  // ------------------------------------------------------------
  const isOrganizationLocked =
    Boolean(urlOrganization) && urlOrganization.disabled === true

  const availableOrganizations = useMemo(() => {
    if (isOrganizationLocked && urlOrganization) {
      return [urlOrganization]
    }

    return organizationData
  }, [organizationData, isOrganizationLocked, urlOrganization])

  // Names allowed in the organization dropdown.
  const availableOrganizationNames = useMemo(() => {
    return availableOrganizations
      .map((organization) => organization?.organizationName)
      .filter(Boolean)
  }, [availableOrganizations])

  // ------------------------------------------------------------
  // Keep organization filter valid when URL/API data changes.
  // ------------------------------------------------------------
  useEffect(() => {
    if (loadingOrganizations) return

    if (isOrganizationLocked && urlOrganization) {
      const organizationName = urlOrganization.organizationName || ''

      setOrgFilter(organizationName)
      setSelectedOrg(organizationName)
      setSelectedProduct('')
      setSelectedTouchpoint('')
      return
    }

    // If there is no URL organization or it is not disabled,
    // keep the normal "All Organizations" selection.
    if (
      orgFilter !== 'all' &&
      !availableOrganizationNames.includes(orgFilter)
    ) {
      setOrgFilter('all')
    }
  }, [
    loadingOrganizations,
    isOrganizationLocked,
    urlOrganization,
    availableOrganizationNames,
    orgFilter,
  ])

  function Loader({ label = 'Loading' }) {
    const orbitIcons = [
      { Icon: FiUsers, color: '#3B82F6', bg: '#EFF6FF' },
      { Icon: BsBoxSeam, color: '#10B981', bg: '#ECFDF5' },
      { Icon: PiHandTapLight, color: '#8B5CF6', bg: '#F5F3FF' },
      { Icon: HiOutlineLocationMarker, color: '#F97316', bg: '#FFF7ED' },
    ]

    return (
      <div className="dq-loader">
        <div className="dq-orbit-wrap">
          <div className="dq-orbit-ring" />
          <div className="dq-orbit-ring dq-orbit-ring-2" />

          <div className="dq-orbit-spin">
            {orbitIcons.map(({ Icon, color, bg }, i) => (
              <div
                className="dq-orbit-item"
                key={i}
                style={{ transform: `rotate(${i * 90}deg) translate(64px) rotate(-${i * 90}deg)` }}
              >
                <div className="dq-orbit-counter-spin">
                  <div className="dq-orbit-icon" style={{ background: bg }}>
                    <Icon size={18} color={color} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="dq-orbit-center">
            <HiOutlineOfficeBuilding size={26} color="#2563eb" />
          </div>
        </div>

        <div className="dq-loader-text">
          {label}
          <span className="dq-loader-dots">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </div>
        <div className="dq-loader-sub">Fetching the latest field data</div>
      </div>
    )
  }

  useEffect(() => {
    if (loadingOrganizations) return

    let mounted = true

    const getQuotaData = async () => {
      setLoading(true);
      try {
        setLoadingQuota(true)
        setQuotaError('')

        const result = await api.post(
          `${config.new.site_api}/survey/getFieldAuditorOrganizationData`,
          {
            organization: selectedOrg?.toUpperCase() || "",
            city: cityFilter !== 'all' ? cityFilter : "",
            product: selectedProduct || "",
            touchpoint: selectedTouchpoint || "",
          }
        )

        // Supports both `result.data` and `result.data.data` shapes.
        const responseData =
          result?.data?.data || result?.data || result || {}

        const co = responseData?.overview?.overallCount


        if (mounted) {
          setOverallCount(co);


          const quotaData = {
            organizationWise: {
              overallCount: responseData?.organizationWise?.overallCount || 0,
              data: Array.isArray(responseData?.organizationWise?.data)
                ? responseData.organizationWise.data
                : [],
            },

            productNameWise: {
              data: Array.isArray(responseData?.productNameWise?.data)
                ? responseData.productNameWise.data
                : [],
            },

            allTouchpointWise: {
              data: Array.isArray(responseData?.allTouchpointWise?.data)
                ? responseData.allTouchpointWise.data
                : [],
            },

            overview: {
              overallCount: responseData?.overview?.overallCount || 0,
            },
          }

          // First update quota
          setQuota(quotaData)

          // Then stop loader
          setLoadingQuota(false)
          setLoading(false);
        }
        else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Error while getting quota data:', error)

        if (mounted) {
          setQuota(EMPTY_QUOTA)
          setQuotaError('Unable to load quota data.')
          setLoadingQuota(false)
        }
      }
    }

    getQuotaData()

    return () => {
      mounted = false
    }
  }, [loadingOrganizations, cityFilter, selectedOrg, selectedProduct, selectedTouchpoint])

  // ------------------------------------------------------------
  // Clear all filters back to blank ("all"). Resetting this state
  // is enough on its own -- getQuotaData's effect above depends on
  // cityFilter / selectedOrg / selectedProduct / selectedTouchpoint,
  // so clearing them re-triggers the API call with every payload key
  // blank and refreshes the whole dashboard. The organization filter
  // is left alone when it's locked by the URL, since that one isn't
  // meant to be user-clearable.
  // ------------------------------------------------------------
  const areFiltersActive =
    (!isOrganizationLocked && orgFilter !== 'all') ||
    cityFilter !== 'all' ||
    Boolean(selectedProduct) ||
    Boolean(selectedTouchpoint)

  const handleClearFilters = () => {
    if (!isOrganizationLocked) {
      setOrgFilter('all')
      setSelectedOrg('')
    }
    setCityFilter('all')
    setSelectedProduct('')
    setSelectedTouchpoint('')
  }

  const orgRows = useMemo(
    () =>
      quota.organizationWise.data.map((d) => ({
        name: d.organization,
        count: d.count || 0,
        ...breakdownOf(d),
      })),
    [quota.organizationWise.data]
  )
  // const overallCount = quota.organizationWise.overallCount
  const productRows = useMemo(
    () =>
      quota.productNameWise.data.map((d) => {
        const breakdown = breakdownOf(d)
        const overallAchieved =
          groupTotal(breakdown.complete) + groupTotal(breakdown.drop)
        // service intentionally excluded from Overall Achieved / % bar

        return {
          name: d.product,
          count: overallAchieved,
          ...breakdown,
        }
      }),
    [quota.productNameWise.data]
  )

  const productTotal = sum(productRows, (row) => row.count)

  const touchpointRows = useMemo(
    () =>
      quota.allTouchpointWise.data.map((d) => ({
        name: d.touchpoint,
        count: d.count || 0,
        ...breakdownOf(d),
      })),
    [quota.allTouchpointWise.data]
  )
  const touchpointTotal = sum(touchpointRows, (row) => row.count)

  // Stat card counts, straight off the API arrays.
  const totalOrganizations = quota.organizationWise.data.length
  const totalProducts = quota.productNameWise.data.length
  const totalTouchpoints = quota.allTouchpointWise.data.length

  // ------------------------------------------------------------
  // Loading state
  // ------------------------------------------------------------
  if (loadingOrganizations) {
    return (
      <div className="dq-page">
        <style>{STYLES}</style>
        <Loader label="Loading organizations" />
      </div>
    )
  }

  if (loadingQuota) {
    return (
      <div className="dq-page">
        <style>{STYLES}</style>
        <Loader label="Loading Quota" />
      </div>
    )
  }

  if (isInvalidOrganizationUrl) {
    return (
      <div className="dq-invalid-page">
        <style>{STYLES}</style>

        <div className="dq-invalid-card">
          <div className="dq-invalid-icon" aria-hidden="true">
            !
          </div>

          <h1 className="dq-invalid-title">
            Invalid Organization URL
          </h1>

          <p className="dq-invalid-text">
            We couldn’t find an organization matching this URL.
          </p>

          <p className="dq-invalid-text">
            Please use the correct URL.
          </p>

        </div>
      </div>

    )
  }

  return (
    <><section id="all-section" className="admin-header position-relative">

      <nav className="navbar navbar-expand-lg bg-white p-0 border border-bottom" style={{ height: "80px" }}>
        <div className="container-fluid ">
          <a className="navbar-brand1 logo-itemsw logoMain" href="#" target="break"><img src={"../images/new-logo.png"} alt="" style={{ height: "70px", margin: "5px" }} /></a>
          {/* <div dangerouslySetInnerHTML={{ __html: survey?.header && survey.header }}></div> */}
          <ul className="navbar-nav flex-row align-items-center justify-contents-center w-auto">



          </ul>
        </div>

      </nav>
    </section>
      <div className="dq-page">
        <style>{STYLES}</style>

        {/* =======================================================
          Optional API errors
      ======================================================== */}
        {organizationError && (
          <div className="dq-api-error">
            {organizationError}
          </div>
        )}

        {quotaError && (
          <div className="dq-api-error">
            {quotaError}
          </div>
        )}

        {isOrganizationLocked && urlOrganization && (
          <div className="dq-locked-info">
            <HiOutlineOfficeBuilding size={18} />
            <span>
              Organization: <strong>{urlOrganization.organizationName}</strong>
            </span>
            <span className="dq-locked-badge">
              Restricted
            </span>
          </div>
        )}

        <div className="dq-filters">
          <div className="dq-filter">
            <label className="dq-filter-label">
              Organizations
            </label>

            <div
              className={`dq-filter-box ${isOrganizationLocked ? 'dq-filter-box-disabled' : ''
                }`}
            >
              <span className="dq-filter-icon">
                <HiOutlineOfficeBuilding />
              </span>

              <select
                value={
                  isOrganizationLocked
                    ? urlOrganization?.organizationName || ''
                    : orgFilter
                }
                disabled={isOrganizationLocked}
                onChange={(e) => {
                  const value = e.target.value

                  setOrgFilter(value)
                  setSelectedOrg(value === 'all' ? '' : value)
                  setSelectedProduct('')
                  setSelectedTouchpoint('')
                }}
              >
                {!isOrganizationLocked && (
                  <option value="all">
                    All Organizations
                  </option>
                )}

                {availableOrganizations.map((organization) => (
                  <option
                    key={String(organization._id)}
                    value={organization.organizationName}
                  >
                    {organization.organizationName}
                  </option>
                ))}
              </select>

              <FiChevronDown className="dq-filter-caret" />
            </div>
          </div>

          <FilterSelect
            icon={<BsBoxSeam />}
            label="Products"
            value={selectedProduct || 'all'}
            onChange={(value) => {
              setSelectedProduct(value === 'all' ? '' : value)
              setSelectedTouchpoint('')
            }}
            options={dropdownOptions.products}
          />

          <FilterSelect
            icon={<HiOutlineOfficeBuilding />}
            label="Cities"
            value={cityFilter}
            onChange={setCityFilter}
            options={dropdownOptions.cities}
          />

          <FilterSelect
            icon={<PiHandTapLight />}
            label="Touchpoints"
            value={selectedTouchpoint || 'all'}
            onChange={(value) => setSelectedTouchpoint(value === 'all' ? '' : value)}
            options={dropdownOptions.touchpoints}
          />

          <div className="dq-filter-clear">
            <button
              type="button"
              className="dq-clear-btn"
              onClick={handleClearFilters}
              disabled={!areFiltersActive}
            >
              Clear
            </button>
          </div>
        </div>

        <div className="dq-stats">
          {/* <StatCard
          icon={
            <HiOutlineOfficeBuilding
              size={20}
              color="#3B82F6"
            />
          }
          iconBg="#EFF6FF"
          title="Total Organizations"
          value={loadingQuota ? '—' : totalOrganizations}
          subtitle=""
        /> */}
          {/* 
        <StatCard
          icon={<BsBoxSeam size={18} color="#10B981" />}
          iconBg="#ECFDF5"
          title="Total Products"
          value={loadingQuota ? '—' : totalProducts}
          subtitle=""
        />

        <StatCard
          icon={
            <PiHandTapLight
              size={20}
              color="#8B5CF6"
            />
          }
          iconBg="#F5F3FF"
          title="Total Touchpoints"
          value={loadingQuota ? '—' : totalTouchpoints}
          subtitle=""
        /> */}
          <StatCard
            icon={
              <HiOutlineTrophy
                size={20}
                color="#16A34A"
              />
            }
            iconBg="#EFF6FF"
            title="Achivements"
            value={loadingQuota ? '—' : quota.overview.overallCount}
            subtitle=""
          />

          <StatCard
            icon={<HiOutlineCursorArrowRays size={25} color="#F97316" />}
            iconBg="#ECFDF5"
            title="Target"
            value={2880}
            subtitle=""
          />
        </div>

        <Section
          icon={
            <HiOutlineOfficeBuilding
              size={18}
              color="#3B82F6"
            />
          }
          iconBg="#EFF6FF"
          title="Bajaj Organization Wise"
          // subtitle="Total count of responses by Bajaj Organization"
          rows={orgRows}
          total={overallCount}
          countLabel={{
            name: 'Organization',
            pctOf: 'Total',
          }}
          rightControl={
            <div className="dq-badge">
              Overall Count: {overallCount.toLocaleString()}
            </div>
          }
        />

        <Section
          icon={<BsBoxSeam size={16} color="#10B981" />}
          iconBg="#ECFDF5"
          title="Product Wise"
          // subtitle="Breakdown of products under selected organization"
          rows={productRows}
          total={productTotal}
          countLabel={{
            name: 'Product',
            pctOf: 'Organization',
            countColumnLabel: 'Overall Achieved',
            countColumnLabel1: 'Overall Target',
          }}
          showBreakdown
        />

        <Section
          icon={
            <PiHandTapLight
              size={18}
              color="#8B5CF6"
            />
          }
          iconBg="#F5F3FF"
          title="Touchpoint Wise"
          // subtitle="Channel wise count for selected product"
          rows={touchpointRows}
          total={touchpointTotal}
          countLabel={{
            name: 'Touchpoint',
            pctOf: 'Product',
          }}
        // rightControl={
        //   <div className="dq-mini-select">
        //     <BsBoxSeam className="dq-mini-select-icon" />

        //     <select
        //       value={selectedProduct || 'all'}
        //       onChange={(e) => {
        //         const value = e.target.value
        //         setSelectedProduct(value === 'all' ? '' : value)
        //         setSelectedTouchpoint('')
        //       }}
        //     >
        //       <option value="all">All Products</option>
        //       {dropdownOptions.products.map((name) => (
        //         <option key={name} value={name}>
        //           {name}
        //         </option>
        //       ))}
        //     </select>

        //     <FiChevronDown className="dq-filter-caret" />
        //   </div>
        // }
        />
      </div></>
  )
}

export default Quota